import { IClientAllocationDetailed } from '~/services/api/clientAllocation/types';
import { IDictionary } from '~/services/api/dictionaries/types';
import { IClientOptionByTeam } from '~/store/client/types';
import { IOption } from '~/types';
import { ITeamMemberMapped } from '~/utils/clientAllocation';

const getActiveMembers = (
  teamMembers: ITeamMemberMapped[],
  clientAllocation: IClientAllocationDetailed[],
  isCrisis: boolean,
): ITeamMemberMapped[] =>
  teamMembers.filter(teamMember => {
    if (teamMember.isDeleted) {
      return false;
    }

    // Filtering only client allocations for edit crisis allocations
    if (isCrisis) {
      return clientAllocation.some(
        allocation => allocation.user.id === teamMember.id && allocation.isCrisis === isCrisis,
      );
    }

    return true;
  });

const getCurrentAllocations = (
  hasLocationGroupActive: boolean,
  clientAllocation: IClientAllocationDetailed[],
  isCrisis: boolean,
): IClientAllocationDetailed[] => {
  if (hasLocationGroupActive) {
    return clientAllocation.filter(
      cAllocation =>
        !!cAllocation.locationGroups.length &&
        !cAllocation.isArchived &&
        cAllocation.isCrisis === isCrisis,
    );
  }
  if (isCrisis) {
    return clientAllocation.filter(
      cAllocation => !cAllocation.isArchived && cAllocation.isCrisis === isCrisis,
    );
  }

  return clientAllocation.filter(
    cAllocation => !cAllocation.isArchived && cAllocation.isCrisis !== isCrisis,
  );
};

const getAssignedClients = (
  currentAllocations: IClientAllocationDetailed[] = [],
  assignedClients: number[],
): number[] =>
  assignedClients.filter(clientId =>
    currentAllocations.some(allocation =>
      allocation.user?.clients?.some(client => client.id === clientId),
    ),
  );

const getClientsToRender = (
  isGlobalUser: boolean,
  clients: IOption[],
  current: IClientOptionByTeam[],
): {
  name: string;
  id: number;
  photo: string;
  teams: IDictionary[];
}[] => {
  if (isGlobalUser) {
    return current?.map(client => ({
      name: client.name,
      id: Number(client.id),
      photo: client.photo,
      teams: client.teams,
    }));
  }

  return clients.map(client => ({
    name: client.label,
    id: Number(client.value),
    photo: client.photo,
    teams: client.teams,
  }));
};

const getAssignedClientsFromFormValues = (
  formValues: Record<string, number[] | number>,
): Record<string, number[]> =>
  Object.fromEntries(
    Object.entries(formValues as Record<string, number[] | number>).filter(
      ([key]) =>
        key.startsWith('clients') &&
        Array.isArray((formValues as Record<string, number[] | number>)[key]),
    ),
  ) as Record<string, number[]>;

export {
  getActiveMembers,
  getCurrentAllocations,
  getAssignedClients,
  getClientsToRender,
  getAssignedClientsFromFormValues,
};
